const stats = [
  { value: '25+', label: 'Years Experience' },
  { value: '130+', label: 'Homes Sold' },
  { value: '$20M+', label: 'In Sales Volume' },
  { value: '98%', label: 'Client Satisfaction' },
];

const credentials = [
  'Licensed Florida REALTOR®',
  'Certified Residential Specialist (CRS)',
  'Accredited Buyer Representative (ABR)',
  'Senior Real Estate Specialist (SRES)',
  'Tresure Coast Association of REALTORS® Member',
  'Florida REALTORS® Member',
];

export default function AgentProfile() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Photo */}
          <div className="relative">
            <div className="w-full aspect-[4/5] rounded-lg overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_2301ee289320b7e6b234255afbfaa7a7_c6ba7475.jpg"
                alt="Amparo Jarquin - Real Estate Agent"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-amber-500 rounded-lg p-6 text-white text-center hidden md:block">
              <p className="text-4xl font-bold">25+</p>
              <p className="text-sm font-medium mt-1">Years in Florida<br />Real Estate</p>
            </div>
          </div>

          {/* Bio */}
          <div>
            <p className="text-amber-600 text-xs font-semibold tracking-widest uppercase mb-3">Meet Your Agent</p>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Amparo <span className="text-amber-500">Jarquin</span>
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-5">
              Amparo Jarquin is a dedicated Florida real estate professional with over 25 years of experience helping families find their perfect Florida homes. Living in Florida, she has an intimate knowledge of every neighborhood, market trend, and investment opportunity across the Sunshine State.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              Amparo believes that buying or selling a home is one of life&apos;s most important decisions, and she is committed to making that process as smooth, transparent, and rewarding as possible. Her warm, personalized approach has earned her a loyal client base and an outstanding reputation in the Florida real estate community.
            </p>

            {/* Credentials */}
            <div className="mb-8">
              <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wide mb-4">Credentials &amp; Memberships</h3>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {credentials.map((c) => (
                  <li key={c} className="flex items-center gap-2 text-sm text-gray-600">
                    <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-amber-500 text-base"></i>
                    </span>
                    {c}
                  </li>
                ))}
              </ul>
            </div>

            <a
              href="/contact"
              className="inline-flex items-center gap-2 px-8 py-4 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              Work With Amparo
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-24">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-8 bg-stone-50 rounded-lg border border-stone-100">
              <p className="text-4xl font-bold text-amber-500 mb-2">{stat.value}</p>
              <p className="text-gray-600 text-sm font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
